module.exports = __webpack_public_path__ + "img/icon-game-21570.3f70eea9.png";